<!-- todo:ai-review -->
<script setup lang="ts">
import type { BookInfo } from "#layers/books/types";

defineProps<{
  book: BookInfo;
}>();
</script>

<template>
  <NuxtLink :to="book.path" class="block">
    <UCard
      class="hover:ring-2 hover:ring-primary-500 transition-all cursor-pointer h-full"
    >
      <template #header>
        <div class="flex items-start justify-between">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ book.title }}
          </h3>
        </div>
      </template>

      <p
        v-if="book.description"
        class="text-sm text-gray-600 dark:text-gray-400 line-clamp-3"
      >
        {{ book.description }}
      </p>
      <p v-else class="text-sm text-gray-400 dark:text-gray-500 italic">
        No description available
      </p>

      <template #footer>
        <div class="flex items-center justify-between">
          <div class="flex flex-wrap gap-1">
            <UBadge
              v-for="tag in book.tags?.slice(0, 3)"
              :key="tag"
              color="neutral"
              variant="subtle"
              size="xs"
            >
              {{ tag }}
            </UBadge>
          </div>
          <span v-if="book.author" class="text-xs text-gray-500">
            {{ book.author }}
          </span>
        </div>

        <!-- Progress placeholder for future implementation -->
        <div class="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
          <div class="flex items-center justify-between text-xs text-gray-500">
            <span>Progress</span>
            <span>0%</span>
          </div>
          <div
            class="mt-1 h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden"
          >
            <div class="h-full bg-primary-500 rounded-full" style="width: 0%" />
          </div>
        </div>
      </template>
    </UCard>
  </NuxtLink>
</template>
